import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './Partner.css';

class Partner extends Component {
  render() {
    return (
      <div id="contact">
        <div className="container">
          <div className="clear">
            <div className="p-column" style={{paddingLeft:0}}>
              <h2 className="left big">This is collaborative research<br/>without boundaries</h2>
              <p className="left">Zygous Labs is excited to partner across the biomedical community.</p>
              <br/>
              <p className="left">
                <ul>
                  <li>Academic Institutions</li>
                  <li>Life Science Corporations</li>
                  <li>Pharmaceutical and Biotech Companies</li>
                  <li>Interested VCs</li>
                </ul>
              </p>
            </div>
            <div className="p-column">
              <div className="form">
                <form action="https://formspree.io/info@zygouslabs.com" method="POST">
                  <input type="text" name="firstname" placeholder="First Name"/>
                  <input type="text" name="lastname" placeholder="Last Name"/>
                  <input type="email" name="email" placeholder="Email"/>
                  <input type="text" name="role" placeholder="Role"/>
                  <textarea name="questions" placeholder="Questions or Comments"/>
                  <input type="hidden" name="_next" value="/ThankYou" />
                  <input type="hidden" name="_subject" value="New Contact Submission!\" />
                  <input type="hidden" name="_format" value="plain" />
                  <input type="submit" value="Submit"/>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default Partner;



// WEBPACK FOOTER //
// ./src/Partner.js